module.exports = __webpack_public_path__ + "media/shot-fart.eea7fbdf.mp3";